<template>
  <div class="map-container" v-show="locationCtr >= 10">
    <div class="divider" />
    <popUpGSheet :postDetail="postDetail" @close="closeDetails"/>
    <div class="map-locator"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import popUpGSheet from './popupGSheet.vue'
import debounce from 'lodash/debounce'

const SINGAPORE = {
  center: [103.819836, 1.352083],
  zoom: 11
}

export default {
  props: ['attributes'],
  components: {
    popUpGSheet
  },
  data () {
    return {
      map: null,
      showPop: false,
      postDetail: {},
      feedData: [],
      locationCtr: 0
    }
  },
  watch: {
    'map': function (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.map.resize()
        })
      }
    }
  },
  methods: {
    showDetails (post) {
      setTimeout(() => {
        this.postDetail = post
        this.showPop = true
      }, 300)
    },
    closeDetails () {
      this.postDetail = {}
      this.showPop = false
    },
    initMap () {
      this.map = new mapboxgl.Map(Object.assign({
        container: this.$el.querySelector('.map-locator'),
        style: 'mapbox://styles/chachopazos/ckdgv4iih0li51imqy5srqgz7', // stylesheet location
        maxBounds: [[103.58295489648154, 1.1074867904165433], [104.10671710351262, 1.5366481512753188]],
        accessToken: 'pk.eyJ1IjoiY2hhY2hvcGF6b3MiLCJhIjoiY2pkMDN3eW4wNHkwZDJ5bGc0cnpueGNxbCJ9.WWWg_OnK5e7L1RknMliY4A'
      }, SINGAPORE))

      this.map.scrollZoom.disable()
      // Add zoom and rotation controls to the map.
      this.map.addControl(new mapboxgl.NavigationControl())

      this.locationCtr = 0
      this.feedData.forEach((item, i) => {
        if (item.coordinates && !item.is_blocked) {
          this.locationCtr++
          var marker = new mapboxgl.Marker()
            .setLngLat(JSON.parse(item.coordinates))
            .addTo(this.map)

          const mEl = marker.getElement()
          mEl.addEventListener('click', () => { this.showDetails(item) })
        }
      })
    },
    getData () {
      const resourceEndpoint = (process.env.APP_NODE_ENV || process.env.NODE_ENV) === 'production'
        ? 'https://www.straitstimes.com/multimedia/graphics/json/'
        : 'https://st-graphics-dev-json.s3-ap-southeast-1.amazonaws.com/'

      const url = resourceEndpoint + this.attributes.value.gsheet + '/0.json'
      fetch(url)
        .then(res => res.json())
        .then((jsonkeydata) => {
          if (!jsonkeydata) return

          this.feedData = jsonkeydata
          this.initMap()
        })
    },
    windowResize () {
      if (window.innerWidth > 768) {
        this.$el.querySelector('.map-locator').style.height = '100vh'
      } else {
        this.$el.querySelector('.map-locator').style.height = '50vh'
      }
      if (this.map) {
        this.map.resize()
      }
    }
  },
  mounted () {
    const self = this
    this.getData()
    self.windowResize()
    window.addEventListener('resize', debounce(function () {
      self.windowResize()
    }, 100))
  }
}
</script>

<style lang="scss">
.map-container {
  position: relative;
  .map-locator {
    width: 100%;
    height: 100vh;

    .mapboxgl-ctrl-logo, .mapboxgl-ctrl-attrib.mapboxgl-compact:after, .mapboxgl-ctrl-attrib-inner,  {
      display: none;
    }
    .mapboxgl-ctrl-top-right {
      z-index: 0;
    }
  }
  .divider {
    width: 100%;
    max-width: 700px;
    bottom: 0;
    position: absolute;
    margin-bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    border-bottom: 1px dotted #333333;
  }
}
</style>
